<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>代理</el-breadcrumb-item>
			<el-breadcrumb-item>代理申请</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="margin-t-20" style="max-width: 40vw;">
			<el-form :model="agentForm" :rules="rules" ref="agentForm" label-width="100px" class="demo-agentForm">
				<el-form-item label="公司名" prop="name">
					<el-input v-model="agentForm.name"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="name">
					<el-input v-model="agentForm.name"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="name">
					<el-input v-model="agentForm.name"></el-input>
				</el-form-item>
				<el-form-item label="地址" prop="name">
					<el-input v-model="agentForm.name"></el-input>
				</el-form-item>
				<el-form-item label="证件信息" prop="name">
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm">立即申请</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AgentApply',
		data() {
			return {
				agentForm: {},
			}
		},
		methods: {
			submitForm() {

			},

			resetForm() {
				this.$refs.agentForm.resetFields()
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
